export class ConnectorUser {
  id?: string;
  demo?: string;
  email?: string;
  username?: string;
}
